export class MetadataFieldDTO{
    public index!: number;
    public name!: string;
}